import { useOfferRequestSignalR } from '../../hooks/useOfferRequestSignalR';

export function OfferEventsSubscriber() {
  useOfferRequestSignalR();
  return null;
}
